import { Departament } from "interfaces";
import { Employe } from "interfaces";
import { create } from "zustand";

interface EmployeProps {
  employe: Employe | null;
  setDepartament: (employe: Employe | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  isOpenModal: boolean;
  setIsOpenModal: (state: boolean)=> void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  clearAll: () => void;
}

export const useEmployeStore = create<EmployeProps>((set, get) => ({
  employe: null,
  setDepartament: (employe) => {
    set({ employe: employe });
  },
  isEdit: false,
  setIsEdit: (state) => {
    set({ isEdit: state });
  },
  isOpenModal: false,
  setIsOpenModal: (state) => {
    set({ isOpenModal: state });
  },
  handleOpenModal: () => {
    set({ isOpenModal: true });
  },
  handleCloseModal: () => {
    set({ isOpenModal: false });
  },
  clearAll: () => {
    set({
      employe: null,
      isEdit: false,
      isOpenModal: false,
    });
  },
}));